'use client';

import React from 'react';
import { Typography } from '../../../../components';
import { CalendarIcon } from '../../../../components/icons';
import { EarnData } from '../types';

interface DateCellProps {
  data: EarnData;
}

const DateCell: React.FC<DateCellProps> = ({ data }) => {
  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };

  return (
    <div className="flex items-center gap-1">
      <CalendarIcon className="w-3.5 h-3.5" />
      <Typography variant="body3" className="text-dark">
        {formatDate(data.date)}
      </Typography>
    </div>
  );
};

export default DateCell;
